import { MasterDataContainer } from '../../dataAccess/masterDataContainer';
import { CSInfoCacheViewModel } from './cSInfoCacheViewModel';

export class CSInfoCacheContainer extends MasterDataContainer<CSInfoCacheViewModel> {
    constructor(models: Array<CSInfoCacheViewModel>, dataYear: number, version: Date) {
        super(models, dataYear, version);
    }
}
